import Vue from 'vue'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import {
  required,
  email,
  min,
  confirmed,
  ext,
  numeric,
  size,
  length,
} from 'vee-validate/dist/rules'
import CardValidator from 'card-validator'

extend('required', {
  ...required,
  message: 'This field is required',
})
extend('numeric', {
  ...numeric,
  message: 'This field may only contain numeric characters',
})
extend('email', {
  ...email,
  message: 'This field must be a valid email',
})
extend('min', {
  ...min,
  message: 'This field must be at least {length} characters',
})
extend('confirmed', {
  ...confirmed,
  message: 'This field confirmation does not match',
})
extend('ext', {
  ...ext,
  message: 'This field is not a valid file',
})
extend('size', {
  ...size,
  message: 'This field size must be less than {size}KB',
})
extend('cbox_length', {
  ...length,
  message: 'Please check all the following boxes',
})

extend('card_number', {
  message: 'Please enter a valid credit card number.',
  validate: (value) => CardValidator.number(value).isValid,
})

extend('card_exp_month', {
  params: [{ name: 'year', isTarget: true }],
  message: 'Please enter a valid credit card expired month.',
  validate: (value, { year }) => {
    const { isValid, isValidForThisYear } = CardValidator.expirationMonth(value)
    if (year <= new Date().getFullYear()) {
      return isValid && isValidForThisYear
    }
    return isValid
  },
})

extend('card_exp_year', {
  message: 'Please enter a valid credit card expired year.',
  validate: (value) => CardValidator.expirationYear(value).isValid,
})

extend('card_cvv', {
  params: [{ name: 'number', isTarget: true }],
  message: 'Please enter a valid credit card cvv number.',
  validate: (value, { number }) => {
    const { card } = CardValidator.number(number)
    const digit = card ? card.code.size : 3
    return CardValidator.cvv(value, digit).isValid
  },
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
